import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ToastProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ToastProvider>
  </React.StrictMode>
);

// PWA: cuando hay una versión nueva, UpdatePrompt ofrece recargar.
serviceWorkerRegistration.register({
  onUpdate: (registration) => window.dispatchEvent(new CustomEvent("sw-update", { detail: registration })),
});
